import {formatLeistungsart} from '@/helper/leistungsart';

function defaultFilter (value, search) {
  return value != null && typeof value !== 'boolean' && value.toString().toLowerCase().indexOf(search.trim().toLowerCase()) !== -1;
}

export default {
  filters: {
    date(value) {
      if (value === undefined) {
        return '';
      }
      const date = new Date(value);
      return date.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
    currency(value) {
      return (+value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', currencyDisplay: 'symbol' });
    },
    leistungsart(value) {
      return formatLeistungsart(value);
    },
    erledigtAsStatus(value) {
      switch (value) {
        case 'Ja':
          return 'geschlossen';
        case 'Nein':
          return 'offen';
        default:
          return '?';
      }
    },
  },
  methods: {
    customFilter (keys) {
      return function (value, search, item) {
        for (let i=0; i < keys.length; i++) {
          if (defaultFilter(item[keys[i]], search.trim().toLowerCase())) return true;
        }
        return false;
      };
    }
  }
};
